export const withExportColumns = (params = {}, columnKeys = []) => {
  if (!columnKeys?.length) {
    return params
  }

  return {
    ...params,
    columns: columnKeys,
  }
}
